import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { InventoryEntities } from 'client/data/models/inventory';
import { VdpExternalLink } from 'site-modules/shared/components/upper-funnel/vdp-external-link/vdp-external-link';
import { isUnhostedInventory } from 'site-modules/shared/utils/inventory-utils/is-unhosted-inventory';
import { CardCompareSelect } from 'client/site-modules/shared/components/profile/card-compare-select/card-compare-select';
import { SimilarInventoryCardHeader } from './similar-inventory-card-header';
import { SimilarInventoryCardDescription } from './similar-inventory-card-description';

import './similar-inventory-card.scss';

export function SimilarInventoryCard({
  vinData,
  showDealerName = false,
  trackingId = 'view_vehicle',
  trackingValue = '',
  linkUnhostedVins = false,
  compareSelect = null,
  isOneCard = false,
  isMobile = false,
  lazyLoadImage = false,
  className = 'mx-0_25 mx-md-0_5',
}) {
  const isUnhosted = isUnhostedInventory(vinData);
  const isSingleVinOnMobile = isOneCard && isMobile;
  const { vin } = vinData;
  const labelId = `lnk-${vin}`;
  const describeId = `desc-${vin}`;
  const colorDescribeId = `color-${vin}`;

  return (
    <div className={classNames('similar-inventory-card-wrapper pos-r', className)}>
      <VdpExternalLink
        vinData={vinData}
        onlyContent={linkUnhostedVins ? false : isUnhosted}
        trackingId={trackingId}
        trackingValue={trackingValue}
        className={classNames('similar-inventory-card d-flex flex-column', {
          'full-height': showDealerName || (isSingleVinOnMobile && !showDealerName),
          'full-height-dealer': isSingleVinOnMobile && showDealerName,
        })}
        ariaLabelledBy={labelId}
        ariaDescribedBy={`${colorDescribeId} ${describeId}`}
      >
        <SimilarInventoryCardHeader vinData={vinData} lazyLoadImage={lazyLoadImage} colorDescribeId={colorDescribeId} />
        <SimilarInventoryCardDescription
          vinData={vinData}
          showDealerName={showDealerName}
          labelId={labelId}
          describedId={describeId}
        />
      </VdpExternalLink>
      {compareSelect && (
        <CardCompareSelect vinData={vinData} compareSelect={compareSelect} isBottomSkipLink labelId={labelId} />
      )}
    </div>
  );
}

SimilarInventoryCard.propTypes = {
  vinData: InventoryEntities.InventoryVin.isRequired,
  showDealerName: PropTypes.bool,
  trackingId: PropTypes.string,
  trackingValue: PropTypes.string,
  linkUnhostedVins: PropTypes.bool,
  compareSelect: PropTypes.shape({}),
  isOneCard: PropTypes.bool,
  isMobile: PropTypes.bool,
  lazyLoadImage: PropTypes.bool,
  className: PropTypes.string,
};
